import React from "react";

function Footer() {
  return (
    <footer className="text-center pb-[30px] text-xs md:text-sm ">
      <p>Designed & Built by Qozeem O. Salami</p>
      <small>&copy; Copyright Quantech Inc. All Rights Resserved 2023</small>
    </footer>
  );
}

export default Footer;
